export default __webpack_public_path__ + "static/media/call_icon.fcf33b70.svg";